import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  CLIENT_SOURCE_HEADER,
  ClientSourceEnum
} from '@whetstoneeducation/hero-common';
import { EnvService } from '../../env.service';

/**
 * Tells the API which client produced the request so analytics can report web
 * apart from the kiosk and mobile apps. Scoped to our own API because a custom
 * header on a third party URL would need that host to allow it in CORS.
 */
@Injectable()
export class ClientSourceInterceptor implements HttpInterceptor {
  constructor(private envService: EnvService) {}

  public intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if (!request.url.startsWith(this.envService.apiGatewayUrl)) {
      return next.handle(request);
    }

    return next.handle(
      request.clone({
        setHeaders: { [CLIENT_SOURCE_HEADER]: ClientSourceEnum.WEB }
      })
    );
  }
}
